<template>
  <layout-default>
    <div class="admin-panel-logs">
      <v-overlay :value="loading" z-index="4">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <operations-filters
        :traceId="queryParams.traceId"
        :operation="queryParams.operation"
        :type="queryParams.type"
        :from="queryParams.from"
        :to="queryParams.to"
        :email="queryParams.email"
        :operations="dictionaryAuditableOperations"
        :types="dictionaryAuditableTypes"
        @search-run="searchRun"
      />
      <operations-table
        :headers="headers"
        :items="adminOperations"
        :items-per-page="queryParams.pageSize"
        :server-items-length="pagination.totalElements || -1"
        :page="queryParams.page"
        :row-component="'operations-table-row'"
        @to-log="toLog"
        @action:get-data="preGetDataAction"
      />
    </div>
  </layout-default>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import OperationsTable from '@/components/adminPanelLogs/OperationsTable.vue'
import OperationsFilters from '@/components/adminPanelLogs/OperationsFilters.vue'
import LayoutDefault from '@/layouts/LayoutDefault.vue'
import RouterMixin from '@/mixins/router'

export default {
  name: 'AdminPanelLogs',
  components: {
    LayoutDefault,
    OperationsTable,
    OperationsFilters,
  },
  mixins: [RouterMixin],
  data() {
    const today = this.$moment()
    const to = today.endOf('day').toISOString()
    const from = today
      .subtract(30, 'day')
      .startOf('day')
      .toISOString()

    return {
      defaultQueryParams: {
        traceId: '',
        operation: '',
        type: '',
        from,
        to,
        email: '',
        pageNumber: 0,
        pageSize: 50,
      },
      queryParams: {
        traceId: '',
        operation: '',
        type: '',
        from,
        to,
        email: '',
        pageNumber: 0,
        pageSize: 50,
      },
      headers: [
        { text: 'TraceId', value: 'traceId', sortable: false },
        { text: 'Date', value: 'dateTime', sortable: false },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Operation', value: 'operation', sortable: false },
        { text: 'Profile', value: 'profile.lastName', sortable: false },
      ],
    }
  },
  computed: {
    ...mapGetters('userStates', ['getRolename']),
    ...mapState('dictionariesStates', [
      'dictionaryBhUsersRoleIds',
      'dictionaryAuditableOperations',
      'dictionaryAuditableTypes',
    ]),
    ...mapState('adminLogsStates', [
      'loading',
      'adminOperations',
      'adminLogs',
      'pagination',
    ]),
  },
  methods: {
    ...mapActions('adminLogsStates', ['getAdminOperations']),
    getData(data) {
      // redirect if cannot go to the dashboard
      if (this.dictionaryBhUsersRoleIds[this.getRolename] !== 1) {
        this.$router.push('/participants')
        return
      }

      this.getAdminOperations(data)
    },
    searchRun(search = {}) {
      this.getDataAction({
        ...this.defaultQueryParams,
        ...this.queryParams,
        ...search,
      })
    },
    preGetDataAction(data = {}) {
      if (!data.page) data.page = 1
      data.pageNumber = data.page - 1
      this.getDataAction(data)
    },
    toLog(traceId) {
      if (!traceId) return
      this.$router.push({
        name: 'Admin Panel Log View',
        path: '/admin-panel/logs/:id/view',
        params: { id: traceId },
      })
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.admin-panel-logs {
  padding: 1.5 * $gutter $gutter 0 $gutter;
}
</style>
